module.exports = __webpack_public_path__ + "img/rx-station-green.e12c0367.png";